import resetBlocks from '../../utils/resetBlocks';
export default (function (editor) {
  return resetBlocks(editor, editor.value.blocks);
});